export const validateFields = (fieldDefinitions, formData) =>
  fieldDefinitions.reduce((errors, field) => {
    if (!formData[field.name]) {
      errors[field.name] = `${field.label} is required`;
    }
    return errors;
  }, {});

export const isValid = (errors) => Object.keys(errors).length === 0;

export const buildBradenPayload = (formData) => ({
  type: "braden",
  norton: null,
  braden: {
    sensoryPerception: formData.bradenSensoryPerception,
    moisture: formData.bradenMoisture,
    activity: formData.bradenActivity,
    mobility: formData.bradenMobility,
    nutrition: formData.bradenNutrition,
    frictionShear: formData.bradenFrictionShear,
  },
});

export const buildSavePayload = (formData, { name, score }) => ({
  name,
  score,
  ...buildBradenPayload(formData),
});

export const mapAssessmentToFormData = (data) => ({
  bradenSensoryPerception: data?.sensoryPerception ?? null,
  bradenMoisture: data?.moisture ?? null,
  bradenActivity: data?.activity ?? null,
  bradenMobility: data?.mobility ?? null,
  bradenNutrition: data?.nutrition ?? null,
  bradenFrictionShear: data?.frictionShear ?? null,
});

export const buildFieldsWithOptions = (fieldDefinitions, optionsByFieldName) =>
  fieldDefinitions.map((field) => ({
    ...field,
    options: optionsByFieldName[field.name],
  }));

const RISK_LABEL_COLOR_RANGES = [
  { min: 19, max: 23, color: "#36b37e", label: "No Risk" },
  { min: 15, max: 18, color: "#ffc400", label: "Mild Risk" },
  { min: 13, max: 14, color: "#fa9e00", label: "Moderate Risk" },
  { min: 10, max: 12, color: "#f56076", label: "High Risk" },
  { min: 6, max: 9, color: "#de350b", label: "Severe Risk" },
];

export const getRiskColor = (score) => {
  const match = RISK_LABEL_COLOR_RANGES.find((r) => score >= r.min && score <= r.max);
  return match ? match.color : "#8c96a3";
};

export const getRiskLabel = (score) => {
  const match = RISK_LABEL_COLOR_RANGES.find((r) => score >= r.min && score <= r.max);
  return match ? match.label : "Unknown";
};

export const hexToRgba = (hex, alpha = 0.16) => {
  const clean = hex.replace("#", "");
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getOptionLabel = (field, value) => {
  const match = field?.options?.find((opt) => opt.key === value);
  return match?.value ?? "-";
};